export default "__VITE_ASSET__DzaSJbij__"